export default __webpack_public_path__ + "static/media/pointmentTN.c6c470e1.png";